import { countries } from "helpers/countriesHelper";

import { moneyRender } from "./utils";

export const maskCPF = (value) => {
	if (!value) return value;
	const cpf = value.replace(/\D/g, "");
	return cpf
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

export const maskCNPJ = (value) => {
	if (!value) return value;
	const cnpj = value.replace(/\D/g, "");
	return cnpj
		.replace(/(\d{2})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d)/, "$1.$2")
		.replace(/(\d{3})(\d)/, "$1/$2")
		.replace(/(\d{4})(\d)/, "$1-$2");
};

export const maskCreditCard = (value) => {
	if (!value) return value;
	const creditCard = value.replace(/\D/g, "");
	return creditCard
		.replace(/(\d{4})(\d)/, "$1 $2")
		.replace(/(\d{4})(\d)/, "$1 $2")
		.replace(/(\d{4})(\d)/, "$1 $2");
};

export const maskZipCode = (value) => {
	if (!value) return value;
	const zipCode = value.replace(/\D/g, "");
	return zipCode.replace(/(\d{5})(\d)/, "$1-$2");
};

export const maskExpirationDate = (value) => {
	if (!value) return value;
	const expiry = value.replace(/\D/g, "");
	return expiry.replace(/(\d{2})(\d)/, "$1/$2");
};

export const maskBirthDate = (value) => {
	if (!value) return value;
	const birthDate = value.replace(/\D/g, "");
	return birthDate
		.replace(/(\d{2})(\d)/, "$1/$2")
		.replace(/(\d{2})(\d)/, "$1/$2")
		.replace(/(\d{4})(\d)/, "$1");
};

export const maskNumbers = (value) => {
	if (!value) return value;
	return value.replace(/\D/g, "");
};

export const maskAccount = (value) => {
	if (!value) return value;
	const account = value.replace(/\D/g, "");
	return account.replace(/(\d{5})(\d)/, "$1-$2");
};

export const maskMoney = (value, business) => {
	if (!value) return value;
	const numericValue = parseInt(value.replace(/[^0-9]/g, ""));
	return moneyRender(business, numericValue / 100);
};

/**
 * Aplica máscara ao número de telefone com base no prefixo do país
 * @param {Event} e - Evento do input
 * @param {string} prefix - Prefixo: BRA, EUA, etc
 */
export const telephoneMask = (e, prefix) => {
	const country = countries.find((country) => country.prefix === prefix);
	if (!country) {
		console.error(`Prefixo de país não encontrado: ${prefix}`);
		return;
	}
	const { ddi, pattern, phoneExtraPrefixNumber, phonePositionNumberExtraPrefix } = country;

	e.target.maxLength = pattern.maxLength;
	let value = e.target.value;
	let cleanValue = value.replace(/\D/g, "");
	const ddiDigits = ddi.replace(/\D/g, "");

	// Não remove o primeiro dígito mesmo que seja igual ao DDI
	const removePrefix = country.removePrefix ?? true;
	if (removePrefix && cleanValue.startsWith(ddiDigits)) {
		cleanValue = cleanValue.substring(ddiDigits.length);
	}

	const prefixDigit = String(phoneExtraPrefixNumber);
	if (prefixDigit && typeof phonePositionNumberExtraPrefix === "number") {
		const existingPrefix = cleanValue.slice(phonePositionNumberExtraPrefix, phonePositionNumberExtraPrefix + prefixDigit.length);
		const verifyExistingPrefix = existingPrefix === prefixDigit;
		const shouldInsert = cleanValue.length > phonePositionNumberExtraPrefix && existingPrefix !== prefixDigit;

		if (prefixDigit.length > 1) {
			if (verifyExistingPrefix && cleanValue === prefixDigit) {
				cleanValue = cleanValue.slice(0,0);
			}
		}

		if (shouldInsert) {
			cleanValue = cleanValue.slice(0, phonePositionNumberExtraPrefix) + prefixDigit + cleanValue.slice(phonePositionNumberExtraPrefix);
		}
	}


	const formatPositions = [];
	const mask = pattern.mask;

	for (let i = 0; i < mask.length; i++) {
		if ([" ", "-", "(", ")"].includes(mask[i])) {
			formatPositions.push({
				pos: i,
				char: mask[i],
			});
		}
	}

	let formattedValue = "";
	let numIndex = 0;

	for (let i = 0; i < mask.length && numIndex < cleanValue.length; i++) {
		const currentChar = mask[i];
		if ([" ", "-", "(", ")"].includes(currentChar)) {
			formattedValue += currentChar;
		} else if (currentChar === "X") {
			formattedValue += cleanValue[numIndex] || "";
			numIndex++;
		}
	}

	return e.target.value = formattedValue;
};